import React, { useContext, useEffect, useState } from "react";
import { Col } from "reactstrap";
import * as toastr from "toastr";

import Styled from 'styled-components';

import BoxWhite from 'Placements/Components/BoxWhite';
import Button from 'Placements/Components/Button';
import LineBoxReport from 'Placements/Components/LineBoxReport';
import Loader from "Placements/Components/Loader";

import UserContext from "Placements/User.context"
import API from "Placements/API";
import getConfig from "Placements/Utils/GetRequestConfig.util"
import { ContainerFlex } from "Placements/Styles/Global.style";


const DivTitle = Styled.div`
    text-align: center;
    position: relative;
    color: ${(props) => props.theme.main.mainBlue};
    margin: 0 auto;
`;

const ButtonStyled = Styled(Button)`
    width: auto;    
    align-self: center;
    margin: 0 auto;
    margin-bottom: -40px;

    @media (max-width: 768px) {
        padding: 1rem;
        font-size: 1rem;
    }
`;

const ReportData = Styled.div`
    border-top: 1px solid #712ca5;
    padding: 2rem 0 1rem;
    margin: 1rem 2rem 0;

    .report-title~.percent {
        font-size: 2.5rem;
        margin-top: 1rem;
        margin-left: -1rem;

    }

    .report-text {
        padding: 0 4rem;
    }

    .your-reports {
        margin-bottom: 1rem;
        color: #505050;
    }

    .title-reports {
        font-size: 1.2rem;
        margin-top: 0;
        margin-bottom: 0;
        padding-left: 3rem;
    }

    .report {
        display: flex;
    }

    @media (max-width: 480px){

        margin: 0;

    }

    @media (max-width: 768px){

        .report-title{
            
            padding-left: 1rem;
    
        }

        .title-reports {
            padding-left: 1rem;
        }

    } 

`;

const ReportColumn = Styled.div`
    -webkit-box-flex: 1;
    flex: 1;
    padding: 1rem 3rem;

    :first-child {
        border-right: 1px solid #66279b;
    }

    @media (max-width: 768px){

        padding: 1rem;

    } 
`;

const FinalReport = () => {

    const dataContext: any = useContext(UserContext);
    const [isLoading, setLoading] = useState(false);
    const [testPart, setTestPart] = useState<any>({});
    const [testUser, setTestUser] = useState<any>({});
    const [scoreCategory, setScoreCategory] = useState([]);
    const [lastPart, setLastPart] = useState<any>({});
    const [listParts, setListParts] = useState([]);

    useEffect(() => {

        if (dataContext === null) {
            window.location.href = "#/login"
        } else {
            fetchLastUserTest();
        }

    }, []);

    useEffect(() => {

        if (Object.keys(testPart).length !== 0) {

            fetchScoreCategories();
            getLastPart();

        }

    }, [testPart]);

    const fetchLastUserTest = async () => {

        try {

            setLoading(true);

            const response = await API.TesteUsuario.GetLastTest({ idUsuario: dataContext.usuario.Id_Usuario }, getConfig());
            const responseUserTest = await API.TesteUsuario.Get({ id: response.data.ultimoTesteUsuario }, getConfig());

            setTestUser(responseUserTest.data);
            setListParts(responseUserTest.data.TestePartes);

            const responseLastPart = await API.TesteParte.GetInfoLastPart({ idTesteUsuario: responseUserTest.data.Id_Teste_Usuario }, getConfig());
            const responseTestPart = await API.TesteParte.Get({ idTestPart: responseLastPart.data.Id_Teste_Parte }, getConfig());

            setTestPart(responseTestPart.data);

        } catch (error) {

            toastr.error('Não foi possível obter o resultado do teste');
            //console.error(error);
            //window.location.href = "#/login";

        } finally {

            setLoading(false);

        }

    }

    const fetchScoreCategories = async () => {

        try {

            const response = await API.TesteParte.GetScoreCategory({ idTesteParte: testPart.Id_Teste_Parte }, getConfig());
            setScoreCategory(response.data);

        } catch (error) {

            toastr.error('Não foi possível obter a pontuação por categoria');
            console.error(error);
            window.location.href = "#/login";

        }

    };

    const getLastPart = async () => {

        try {

            const listPart = testUser.TestePartes.filter((part: any) => part.Id_Teste_Parte === testPart.Id_Teste_Parte);

            setLastPart(listPart[0]);

        } catch (error) {

            toastr.error('Não foi possível obter o último do teste');
            window.location.href = "#/login";
            console.error(error);

        }

    }

    if (scoreCategory == []) {
        return <Loader />
    }

    return (
        <ContainerFlex>
            <Col md={8} className="mb-4">
                {isLoading && <Loader />}
                <BoxWhite >
                    <DivTitle className='title'>
                        Pronto!
                </DivTitle>
                    <div className="info">
                        <p className="text -center">
                            <strong>Parabéns por completar este teste.</strong>
                        </p>
                        <p className="text -center">
                            Após seu esforço e dedicação, seu resultado e sua nota final foi:
                    </p>
                    </div>
                    <LineBoxReport className="-small">
                        <div className="report-title">
                            {lastPart && lastPart.NomeParte && <div className="test-name">
                                {lastPart.NomeParte}
                            </div>
                            }
                            <div>
                                <strong>{testUser.Nome_Proficiencia}</strong>
                            </div>
                        </div>
                        {testPart.Resultado != null && <div className="percent">
                            {(testPart.Resultado * 100).toFixed(1)} %
                        </div>
                        }
                    </LineBoxReport>
                    <div className="info">
                        <p className="text -center report-text">
                            Você está pronto para dar o próximo passo e virar um cidadão do mundo? Temos o curso perfeito para você e suas necessidades.
                            O coordenador da escola entrará em contato e vai ajudá-lo a encontrar a melhor opção de curso.
                        </p>
                    </div>
                    <ReportData>
                        <h5 className="title-reports">Your Reports</h5>
                        <div className="report">
                            <ReportColumn>
                                {scoreCategory.map((score: any, index) => (
                                    <div className="item" key={index}>
                                        <span>
                                            {score.Nome + " - "}
                                        </span>
                                        <strong className="percent">
                                            {(score.Resultado * 100).toFixed(1)}%
                                    </strong>
                                    </div>
                                ))}
                            </ReportColumn>
                            <ReportColumn>
                                {listParts.map((part: any, index: number) => (
                                    <div className="item" key={index}>
                                        {part.NomeParte && <span>
                                            {part.NomeParte + " - "}
                                        </span>
                                        }
                                        <strong className="percent">
                                            {(part.Resultado * 100).toFixed(1)} %
                                        </strong>
                                    </div>
                                ))}
                            </ReportColumn>
                        </div>
                    </ReportData>
                    <div className="report-actions">
                        <ButtonStyled onClick={() => { window.print() }}>
                            Imprimir resultado
                    </ButtonStyled>
                        <ButtonStyled onClick={() => { window.open("https://www.yazigi.com.br/") }}>
                            Conheça o Yázigi!
                    </ButtonStyled>
                    </div>
                </BoxWhite>
            </Col>
        </ContainerFlex>
    );

}

export default FinalReport;